import style from "../style/card.module.css";

export default function Card({ img, name, result }) {
  return (
    <div
      className={style.card}
      style={{
        opacity: result ? 1 : undefined,
        width: result ? "50%" : undefined,
      }}
    >
      <div className={style.card_img}>
        <img src={img} alt={name} />
      </div>
      {result && (
        <video className={style.vid} autoPlay muted>
          <source src="/worldcup/fire.mp4" />
        </video>
      )}

      {name}
    </div>
  );
}
